export type TitleTemplate = { org?: string; text: string };

// Commonly used document titles for KSG domain
export const TITLE_TEMPLATES: TitleTemplate[] = [
  { org: 'KSG', text: 'Glazing Works at Property' },
  { org: 'KSG', text: 'Window Replacement (Double Glazing)' },
  { org: 'KSG', text: 'Front/Rear Door Replacement' },
  { org: 'KSG', text: 'Misted/Failed Unit Replacement' },
  { org: 'KSG', text: 'Repairs & Servicing (Hinges/Handles/Seals)' },
];















